module.exports = __webpack_public_path__ + "img/export-excel.7fb0bd26.svg";